<template>
    <div class="content">
        <table style="align-items: left">
            <thead>
                <tr>
                    <th class="title"
                        colspan="3">
                        <font face='Arial'
                            size="6vh">LISA MONITOR<br>
                        <span class="sss">SYSTEMS SOLVENT STATE</span></font>
                    </th>
                </tr>
                <tr class="colnames">
                    <th><span>ELUENTS</span></th>
                    <th class="padded"><span>WASTE</span></th>
                    <th class="padded last"><span>SYSTEM DETAILS / INFORMATION</span></th>
                </tr>
            </thead>
            <tbody>
                <tr class="system" @click="$event.target.focus()"
                    v-for="system, index in systems"
                    v-if="system.state">
                    <td class="state1container">
                        <div class="state"
                            :class="'state_'+system.state.eluent"></div>
                    </td>
                    <td class="state2container">
                        <div class="state"
                            :class="'state_'+system.state.waste"></div>
                    </td>
                    <td class="namecontainer">
                        <div>
                            <span class="name"><b>{{system.state.name || system.id}}</b><span class="edit"><font-awesome-icon icon="edit" @click="editName(system)"/>&nbsp;&nbsp;<font-awesome-icon icon="trash" @click="removeSystem(system)"/></span></span>
                            <span>{{system.message}}</span>
                            <div class="bulbcontainer" @click="toggleLED(system)">
                                <font-awesome-icon v-show="system.state.led === system.led" class="bulb" :icon="['far', 'lightbulb']"/>
                                <font-awesome-icon v-show="system.state.led && system.led" class="bulb enabled" icon="lightbulb"/>
                                <font-awesome-icon spin v-show="system.state.led !== system.led" class="bulb loading" icon="spinner"/>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <font-awesome-icon :icon="['far', 'plus-square']" size="4x" @click="addSystem()"/>
                </tr>
                <tr class="padder"></tr>
            </tbody>
        </table>
        <div class="logo">
            <img src="logo.png"
                class="logo">
        </div>
        <div class="swalcontainer" id="newIdContainer">
            <input class="swal-content__input" v-model="newId" @keydown.delete="handleDelete" @input="formatAndVerifyId">
        </div>
        <div class="swalcontainer" id="nameChangeContainer">
            <input class="swal-content__input" v-model="newName">
        </div>
    </div>
</template>

<script>


var callInterval = 1000;
    export default {
        props: ['updateLED', 'systems', 'connectSystem', 'saveName'],
        data: function(){
            return{
                newId: '',
                newName: '',
                newIdContainer: null,
                nameChangeContainer: null
            }
        },
        mounted: function() {
            this.updateTimes();
            setInterval(this.updateTimes, callInterval);
            this.newIdContainer = document.getElementById('newIdContainer');
            this.nameChangeContainer = document.getElementById('nameChangeContainer');
        },
        methods: {
            editName(system){
                this.newName = system.state.name || system.id;
                swal({
                    title: 'Enter the new name',
                    content: this.nameChangeContainer,
                    button: {
                        text: 'Save'
                    }
                })
                .then((confirmed) => {
                    this.saveName(system, this.newName);
                })
            },
            removeSystem(system){
                swal({
                    title: `Do you want to remove ${system.name || system.id}?`,
                    icon: "warning",
                    buttons: true,
                    dangerMode: true                  
                })
                .then((confirmed) => {
                    if(confirmed){
                        this.systems.splice(this.systems.findIndex(s=>system.id === s.id), 1);
                        let deviceIds = JSON.parse(localStorage.deviceIds || '[]');
                        deviceIds.splice(deviceIds.indexOf(system.id));
                        localStorage.deviceIds = JSON.stringify(deviceIds);
                    }
                })
            },
            handleDelete(){
                if(this.newId.match(/-$/)){
                    this.newId = this.newId.substring(0, this.newId.length - 1);
                }
            },
            verifyId(){
                let id = this.newId.replace(/[^a-z0-9]/g, '');
                id = id.substring(0, 9);

                const glyphs = '0123456789abcdefghijklmnopqrstuvwxyz';
                const primes = [1,2,3,5,7,11,13,17,-1];
                let idOk = false;
                if(id.length === 9){
                    let sum = 0;
                    for(let i = 0; i < 9; i++){
                        sum += primes[i]*glyphs.indexOf(id[i]);
                    }
                    idOk = sum%glyphs.length === 0;
                }
                return idOk?id:false;
            },
            formatAndVerifyId(){
                let id = this.newId.toLowerCase().replace(/[^a-z0-9]/g, '');
                id = id.substring(0, 9);

                let confirm = document.querySelector('.swal-button--confirm');
                if(confirm){
                    confirm[(this.verifyId()?'remove':'set')+'Attribute']('disabled', true);
                }

                
                let formatted = '';

                for(let i = 0; i < id.length; i++){
                    formatted += id[i];
                    if(i % 3 === 2 && i < 8){
                        formatted += '-';
                    }
                }
                this.newId = formatted;
            },
            addSystem(){
                swal({
                    title: 'Enter the device ID',
                    content: this.newIdContainer,
                    button: {
                        text: 'Connect',
                        closeModal: false
                    }
                })
                .then((confirmed) => {
                    if(!this.verifyId()){
                        return;
                    }
                    if(this.systems.find(system=>system.id === this.newId)){
                        swal(`${this.newId} has already been added!`);
                        return;
                    }
                    let done = false;
                    this.connectSystem(this.newId, ()=>{
                        done = true;
                        swal.close();
                        let deviceIds = JSON.parse(localStorage.deviceIds || '[]');
                        deviceIds.push(this.newId);
                        localStorage.deviceIds = JSON.stringify(deviceIds);
                        this.newId = '';
                    });
                    setTimeout(()=>{
                        if(!done){
                            swal(`Could not find ${this.newId}`);
                            this.systems.splice(this.systems.findIndex(system=>system.id === this.newId), 1);
                        }
                    }, 5000)
                })
                this.formatAndVerifyId();
            },
            updateTimes(){
                //console.log('updateTimes')
                for(var i = 0; i < this.systems.length; i++){
                    //console.log(this.systems[i])
                    if(this.systems[i].metadata){
                        let timestamp = this.systems[i].metadata.online.timestamp;
                        let minutes = Math.floor((Date.now()/1000 - timestamp)/60);
                        let message;
                        if(!this.systems[i].state.online){
                            if(minutes <= 3){
                                message = 'just now';
                            }else if(minutes < 60){
                                message = 'last seen '+minutes+' minutes ago';
                            }else{
                                message = 'last seen @ '+this.fullDate(timestamp*1000);
                            }
                        }else{
                            message = 'Online';
                        }
                        this.$set(this.systems[i], 'message', message);
                    }
                }
            },
            fullDate: function(timestamp) {
                var d = new Date(timestamp);
                return `${this.leadingZeros(d.getDate(),2)}.${this.leadingZeros(d.getMonth()+1,2)}.${d.getFullYear()} ${this.leadingZeros(d.getHours(),2)}:${this.leadingZeros(d.getMinutes(),2)}:${this.leadingZeros(d.getSeconds(),2)}`;
            },
            leadingZeros: function(val, cnt) {
                return ('00000000000000'+val).slice(-cnt);
            },
            toggleLED(system){
                system.led = !system.led
                this.updateLED(system);
            }
        }
    }
</script>

<style lang="scss">
    html {
        background-color: #E7F5F5;
        width: 100%;
        height: 100%;
    }
    body {
        color: #1C3F86;
        border: 20px solid #1C3F86;
        border-radius: 40px;
        outline: 20px #1C3F86 solid;  /* inner stroke */
        outline-offset: -20px;  /* negative border width + outline width */
        height: calc(100% - 40px);
        width: calc(100% - 40px);
        position: fixed;
        margin: 0;
    }
    table {
        opacity: 0.9;
        margin-top: 20px;
        margin-left: 16px;
        width: calc(100% - 40px);
        border-collapse: collapse;
    }
    table, th, td {
        padding: 0;
    }
    th, td {
        padding: 0;
        text-align: left;
    }
    h1 {
        padding-left: 1.7vw;
        padding-top: 2vh;
        padding-bottom: 0;
        height: 10px;
    }
    .logo {
        position: fixed;
        bottom: 23px;
        right: 35px;
    }
    .state {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin: 5px 3px;
    }
    .state_0 {
        background-color: green;
    }
    .state_1 {
        background-color: orange;
    }
    .state_2 {
        background-color: red;
    }
    .state_3 {
        background-color: red;
    }
    .namecontainer {
        width: 100%;
        padding-left: 13px;
    }
    .state1container {
        padding-left: 13px;
    }
    .state2container {
        padding-left: 22px;
    }
    tbody .namecontainer {
        font-size: 28px;
    }
    .name {
        position: relative;
        .edit {
            min-width: 100px;
            width: 100%;
            position: absolute;
            left: 0;
            text-align: center;
            background-color: rgba(255, 255, 255, 0.7);
            border-radius: 4px;
        };
    }
    .title {
        padding-bottom: 8px;
    }
    .system:hover, .system:focus {
        background-color: rgba(100, 100, 100, 0.5);
        .edit {
            display: inline-block;
        }
    }
    .system {
        transition: background-color 0.2s ease-in-out;
        background-color: #fff;
        padding-bottom: 1px;
    }
    tr td:first-child {
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
    }
    tr td:last-child {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
    }
    @media (max-width: 680px) {
        .name {
            padding-bottom: 4px;
        }
    }
    .logo {
        width: 300px;
    }
    @media (max-width: 600px) {
        .logo {
            width: 500px;
        }
    }
    .edit {
        display: none;
    }
    
    .container {
        border: 1px solid red;
    }
    tbody {
        height: calc(100vh - 182px);
        overflow: auto;
    }
    ::-webkit-scrollbar {
        display: none;
    }
    tbody, tfoot, thead {
        display: block;
    }
    .padder {
        height: 50px;
    }
    .newname {
        width: 150px;
    }


    
    a {
        color: inherit;
        text-decoration: none;
    }
    .colnames {
        font-style: italic;
    }
    .colnames .padded{
        padding-left: 3px;
    }
    .colnames span{
        color: #fff;
        background-color: #1C3F86;
        border-radius: 5px;
    }
    .colnames span{
        padding: 4px;
    }
    .sss{
        font-weight: 100;
    }
    .padded.last{
        width: 100%;
    }
    .bulbcontainer {
        float: right;
        height: 30px;
        width: 30px;
        margin-right: 4px;
        position: relative;
        .bulb {
            position: absolute;
            left: 5px;
            top: 0;
            &.enabled {
                animation: blink-animation 0.6s steps(2, start) infinite;
            }
            &.loading {
                left: 0;
                pointer-events: none;
            }
        }
    }
    @keyframes blink-animation {
      to {
        visibility: hidden;
      }
    }
    
    .content .swalcontainer {
        display: none;
    }
</style>




// WEBPACK FOOTER //
// src/components/Overview.vue